/**
 * How to reach us, in the one place both apps and every page can read it.
 *
 * The address was typed into seven files: the in-app help screen, the contact
 * page, the marketing footer, both legal documents, and the JSON-LD block
 * search engines read. Two of them had already given it a constant of its own
 * with a different name (`CONTACT_EMAIL`), which is how a mailbox gets
 * changed in six places out of seven and the seventh keeps sending people
 * somewhere nobody reads.
 *
 * Not a settings-table row, unlike the company's own particulars: this is the
 * address the product itself answers on, it is baked into structured data
 * Google caches, and changing it is a deploy either way.
 */
export const SUPPORT_EMAIL = 'support@snily.com';
